__webpack_require__.p = "https://inventario.affarintech.com/";